import { Sidebar } from "@/components/kit";
import { cn } from "@/lib/utils";
import { useLayout } from "../providers/LayoutProvider";

export function AppSidebar({
  className,
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  const { collapsible, variant } = useLayout();
  return (
    <Sidebar
      collapsible={collapsible}
      variant={variant}
      className={cn(
        "[&_[data-slot=sidebar-inner]]:border-secondary/15 [&_[data-slot=sidebar-inner]]:shadow-sm",
        className,
      )}
      {...props}
    />
  );
}
